import { languageNames, languages, type Language } from '@smarton-pbx/shared';
import { language, showLanguage, t } from '../i18n';

/**
 * English | Lietuvių. With `save`, the choice is kept for the person (in
 * every browser and the phone app) before the page switches; without it
 * (signed out), for this browser.
 */
export function LanguageSwitch({ save }: { save?: (next: Language) => Promise<unknown> }) {
  async function choose(next: Language) {
    if (next === language) return;
    await save?.(next).catch(() => undefined);
    showLanguage(next);
  }
  return (
    <div className="segmented" role="group" aria-label={t('Language')}>
      {languages.map((code) => (
        <button
          key={code}
          type="button"
          className={code === language ? 'active' : ''}
          aria-pressed={code === language}
          lang={code}
          onClick={() => void choose(code)}
          data-testid={`language-${code}`}
        >
          {languageNames[code]}
        </button>
      ))}
    </div>
  );
}
